import WorkItem from '@/components/WorkItem/WorkItem';
import WorkItemFullWidth from '@/components/WorkItem/WorkItemFullWidth';
import { Category, PageInfo, Work } from 'generated-graphql';
import { WORKS, getWorks } from 'gql/works';
import { CATEGORIES } from 'gql/categories';
import { initializeApollo } from 'lib/apolloClient';
import { getGlobalData } from 'lib/global';
import { GetServerSideProps, GetStaticPropsContext } from 'next';
import { ChangeEvent, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import Filters from '@/components/Filters/Filters';
import appConfig from '@/app.config';
import ResourceItem from '@/components/ResourceItems/ResourceItem';
import ResourceItemFullWidth from '@/components/ResourceItems/ResourceItemFullWidth';
import SEO from '@/components/SEO/SEO';


interface SelectedCategoryType {
  label: string;
  value: string;
}

export interface SelectedCategoriesType {
  [key: string]: SelectedCategoryType | null;
}

const WorkList = ({
  pageData,
  categories,
  selectedCategories,
  featured
}: {
  pageData: Work[];
  categories: Category[];
  selectedCategories: SelectedCategoriesType;
  featured: Work[];
}) => {

  const [filters, setFilters] =
    useState<SelectedCategoriesType>(selectedCategories);
  const [items, setItems] = useState<Work[]>([...featured, ...pageData.filter((p) => !featured.find((f) => f.id === p.id))]);
  const [filterItems] = useLazyQuery(
    getWorks(
      Object.keys(filters)
        .filter((key) => filters[key] && filters[key]?.label)
        .map((f) => filters[f]?.label || ''),
    ),
  );
  const router = useRouter();

  // const { pathname } = router;
  const handleFilter = (category: string, option?: string, id?: string) => {
    const newFilters = {
      ...filters,
      [category]: !option ? null : { value: id || '', label: option || '' },
    };

    const filterQuery = {} as any;

    Object.keys(newFilters).forEach((filter) => {
      if (newFilters[filter]?.label) {
        filterQuery[filter] = newFilters[filter]?.label;
      }
    });

    // router.push(
    //   {
    //     pathname,
    //     query: filterQuery,
    //   },
    //   undefined,
    //   {
    //     shallow: true,
    //   },
    // );
    setFilters(newFilters);

    filterItems({
      onCompleted: (data) => {
        const featuredItems = data.works.nodes.filter((p: Work) => featured.find((f) => f.id === p.id));
        const otherItems = data.works.nodes.filter((p: Work) => !featured.find((f) => f.id === p.id));
        setItems([...featuredItems, ...otherItems]);
      },
    });
  };

  return (
    <div style={{ marginTop: '100px' }}>
      <SEO title='Work - Agent3' og={{ title: "Our award winning case studies.", siteName: "Agent3" }} />

      <div className='container'>
        <div className='row'>
          <div className='col-xl-7 mb-5 mt-5'>
            <p className='md semibold mb-3'>Our work</p>
            <h1 className='xl'>Our award winning case studies.</h1>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <Filters categories={categories} filters={filters} onFilter={handleFilter} isWork={true} />
          <div className={`col-md-9 mainList`} >
            <div className='row'>
              <div className="col-12 px-3">
                {items.length > 0 && (
                  // <WorkItemFullWidth item={items[0]} />
                  <ResourceItemFullWidth item={items[0]} />

                )}
              </div>
              {items.slice(1).map((w, idx) => (
                <div key={idx + 'work'} className="col-12 mb-4 col-xl-6 px-3">
                  <ResourceItem isWorkListing item={w} isFeatured={!!featured.find((item) => item.id === w.id) && idx < 4} hideExcerpt />
                  {/* <WorkItem item={w} /> */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkList;

// export const getServerSideProps: GetServerSideProps = async (context) => {
export async function getStaticProps(context: GetStaticPropsContext) {
  // const { query } = context;
  const apolloClient = initializeApollo();

  const selectedCategories: {
    [key: string]: { label: string; value: string };
  } = {};

  const categoriesQuery = await apolloClient.query({
    query: CATEGORIES,
    variables: { names: ['What we do'] },
  });
  const categories = get(categoriesQuery, 'data.categories.nodes', []);
  const categoryLabels: string[] = [];
  // if (query) {
  //   categories.forEach((c: Category) => {
  //     const subCategories: Category[] = get(c, 'children.nodes', []);
  //     if (c.slug && Object.keys(query).includes(c.slug)) {
  //       const selectedCategory = subCategories.find(
  //         (subc) => subc.name === query[c?.slug as string],
  //       );
  //       if (selectedCategory) {
  //         categoryLabels.push(selectedCategory.name || '');
  //         selectedCategories[c.slug] = {
  //           label: selectedCategory.name || '',
  //           value: selectedCategory.id,
  //         };
  //       }
  //     }
  //   });
  // }
  const results = await apolloClient.query({
    query: getWorks(
      categoryLabels,
    ),
  });

  const featured = await apolloClient.query({
    query: getWorks(
      ["Featured", ...categoryLabels]
    ), variables: {
      first: 3,
    }
  });

  const pageProps = {
    pageInfo: results.data?.works?.pageInfo,
    pageData: results.data?.works?.nodes || [],
    featured: featured.data?.works?.nodes || [],
    categories: categories.filter((el: Category) => el.name !== 'Featured'),
    selectedCategories: selectedCategories || {},
  };

  return await getGlobalData(pageProps, apolloClient, { revalidate: appConfig.revalidate });
};
